import React from "react";
import { ReleaseLine } from "./releaseTypes";

/** Manual lines added to a release; unpriced shows product + quantity only. */
function ReleaseLinesTable({ lines, priced = true, onRemove }: ReleaseLinesTableProps) {
  if (!lines.length) return null;
  const headers = priced
    ? ["No", "Product", "Unit Price", "Qty", "Discount", "Net Total", ""]
    : ["No", "Product", "Qty", ""];

  return (
    <div className="border border-slate-200 dark:border-slate-600 rounded-lg overflow-x-auto">
      <table className="w-full text-xs">
        <thead className="bg-slate-50 dark:bg-slate-700/50">
          <tr>
            {headers.map((title, i) => (
              <th key={i} className="px-2.5 py-1.5 text-left text-[10px] font-semibold text-slate-500 dark:text-slate-300 uppercase">
                {title}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="divide-y divide-slate-100 dark:divide-slate-600">
          {lines.map((item, i) => (
            <tr key={`${item.productId}-${i}`} className="hover:bg-slate-50 dark:hover:bg-slate-700/50">
              <td className="px-2.5 py-1.5 text-xs text-slate-500 dark:text-slate-400">{i + 1}</td>
              <td className="px-2.5 py-1.5 font-medium text-xs text-slate-700 dark:text-slate-200">{item.productName}</td>
              {priced && <td className="px-2.5 py-1.5 text-xs text-slate-600 dark:text-slate-300">{item.unitPrice}</td>}
              <td className="px-2.5 py-1.5 text-xs text-slate-600 dark:text-slate-300">
                {item.quantity} {item.scale}
              </td>
              {priced && <td className="px-2.5 py-1.5 text-xs text-slate-600 dark:text-slate-300">{item.discount}</td>}
              {priced && (
                <td className="px-2.5 py-1.5 font-semibold text-xs text-emerald-600 dark:text-emerald-400">{item.netTotal}</td>
              )}
              <td className="px-2.5 py-1.5 text-right">
                <button
                  type="button"
                  onClick={() => onRemove(i)}
                  className="text-red-500 dark:text-red-400 hover:text-red-700 dark:hover:text-red-300 text-[10px] font-medium"
                >
                  Remove
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default ReleaseLinesTable;

interface ReleaseLinesTableProps {
  lines: ReleaseLine[];
  priced?: boolean;
  onRemove: (index: number) => void;
}
